import { Filter } from "../../types";
import { EditorFilter } from "../types";

// // // //

/**
 * buildFilterFromEditorFilter
 * Builds a Filter object from an EditorFilter.
 * @function buildFilterFromEditorFilter
 * @param {EditorFilter} editorFilter - The EditorFilter to build the Filter object from.
 * @returns {Filter} - The generated Filter object.
 */
export function buildFilterFromEditorFilter(
    editorFilter: EditorFilter,
): Filter {
    const filter = editorFilter.state;

    if (filter.filters) {
        return {
            ...filter,
            filters: editorFilter.nested.map((f) =>
                buildFilterFromEditorFilter(f),
            ),
        };
    }

    return filter;
}
